// //Config.js
// export const API_BASE_URL = "https://bsv-app.azure-api.net/api/";
 export const API_BASE_URL2= "https://bsv-app.azure-api.net/uat/api/"


const environment = process.env.REACT_APP_ENV || 'production';

const API_URLS = {
  // development: process.env.REACT_APP_DEV_API_BASE_URL || 'https://bsv-app.azure-api.net/dev/api/',
  development: process.env.REACT_APP_DEV_API_BASE_URL || 'http://bsv-analytics-prod.0a6418a61f9c4aeb86ee.centralindia.aksapp.io/api/',

  uat: process.env.REACT_APP_UAT_API_BASE_URL || 'http://bsv-analytics-prod.0a6418a61f9c4aeb86ee.centralindia.aksapp.io/api/',
  production: process.env.REACT_APP_PROD_API_BASE_URL || 'https://bsv-analytics-prod.0a6418a61f9c4aeb86ee.centralindia.aksapp.io/api/',
};

export const API_BASE_URL = API_URLS[environment] || 'https://bsv-analytics-prod.0a6418a61f9c4aeb86ee.centralindia.aksapp.io/api/';

//https://bsv-analytics-uat.0a6418a61f9c4aeb86ee.centralindia.aksapp.io/api/User/UserDetails

